// extracted by mini-css-extract-plugin
export default {"devops":"DevOps_devops__Z0keT"};